import { Post } from '../index';

const BASE_URL = '/login';

export interface PostLoginReq {
	isNotification: boolean;
	isKdShop: boolean;
	accountType: 'ADMIN_USER' | 'USER' | 'PHARM_USER';
	loginId: string;
	password: string;
}

export interface PostLoginRes {
	accessToken: string;
	accessTokenExpiresAt: string;
	refreshToken: string;
	refreshTokenExpiresAt: string;
}

export const login = {
	postLogin: async <T = PostLoginRes>(params: PostLoginReq): Promise<T> => (await Post<T>(BASE_URL, params)).data,
};
